<template>
  <v-content>
    <div id="login">
      <div id="main" style>
        <div
          style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            height: 100vh;
            overflow-y: hidden;
          "
        >
          <vue-particles
            color="#ffffff"
            :particle-opacity="0.27"
            :particles-number="24"
            shape-type="circle"
            :particle-size="3"
            lines-color="#ffffff"
            :lines-width="1.1"
            :line-linked="true"
            :line-opacity="0.33"
            :lines-distance="192"
            :move-speed="1.6"
            :hover-effect="false"
            :click-effect="false"
          ></vue-particles>
        </div>

        <div style="position: relative">
          <div v-show="error" class="alert-danger alert-header">
            <v-container style="padding-top: 10px; padding-bottom: 10px">
              <v-layout wrap>
                <v-flex xs10 sm11>
                  <v-layout>
                    <vue-simple-svg
                      :filepath="'/static/img/assets/_global/warning.svg'"
                      width="30px"
                      height="auto"
                      class="icon mr-2 mt-2"
                    />
                    <div class="pt-2 pl-2">{{ error }}</div>
                  </v-layout>
                </v-flex>
                <v-flex xs2 sm1 class="text-xs-right">
                  <v-btn dark flat fab small class="ma-0" @click="error = undefined">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
          <v-toolbar flat color="transparent" style="background: transparent">
            <v-spacer></v-spacer>

            <lang-dropdown></lang-dropdown>
          </v-toolbar>

          <v-container>
            <div class="text-xs-center">
              <v-layout wrap>
                <v-flex xs12 sm8 offset-sm2 md6 offset-md3 lg4 offset-lg4>
                  <v-img
                    class="brand responsive-img"
                    :src="$store.state.theme.logo"
                    alt="zwiz.ai"
                    style="margin: 0px auto 50px; width: 100%; max-width: 300px"
                  />
                  <p class="caption" style="color: white">
                    {{ $t('Register once for two platforms') }}
                  </p>
                  <div
                    class="pt-3 pb-3 mb-4"
                    style="background: rgba(255, 255, 255, 0.2); border-radius: 10px"
                  >
                    <v-layout>
                      <v-flex class="text-xs-center" style="border-right: 1px solid white">
                        <img
                          src="/static/img/assets/login/messenger-logo.png"
                          alt
                          class="responsive-img"
                        />
                        <div style="color: white">
                          Facebook
                          <br />Chatbot
                        </div>
                      </v-flex>
                      <v-flex>
                        <img
                          src="/static/img/assets/login/line-logo.png"
                          alt
                          class="responsive-img"
                        />
                        <div style="color: white">
                          Line
                          <br />Chatbot
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>

                  <v-btn
                    large
                    color="#3C5A99"
                    class="mb-3 mx-0"
                    dark
                    style="width: 100%"
                    :loading="loading"
                    @click="onSignIn"
                  >
                    <em class="fab fa-facebook-square mr-2" />
                    <span>{{
                      isNewBusinessAccount ? 'เชื่อมต่อเพจรูปแบบใหม่' : $t('Get Started for Free')
                    }}</span>
                  </v-btn>

                  <v-dialog
                    v-model="isGetStarted"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                  >
                    <v-card>
                      <template v-if="$store.state.isLoggedIn">
                        <div id="get-started">
                          <get-started @close="isGetStarted = false"></get-started>
                        </div>
                      </template>
                    </v-card>
                  </v-dialog>

                  <a
                    v-if="!$store.state.theme.hide_zwiz"
                    href="https://blog.zwiz.ai/getstarted-zwizai/"
                    target="blank"
                    style="color: white"
                    class="mb-5 mt-2"
                  >
                    {{ $t('How to Install and use ZWIZ.AI Chatbot') }}
                    <em class="fas fa-question-circle" />
                  </a>
                  <div>
                    <a
                      v-if="!$store.state.theme.hide_zwiz"
                      href="https://www.messenger.com/t/361231620965547"
                      target="blank"
                      style="color: white"
                      class="mb-5 mt-2"
                    >
                      {{ $t('Need help?') }}
                      <em class="fas fa-question-circle" />
                    </a>
                  </div>

                  <p class="caption" style="color: white; margin-top: 45px">
                    Powered by Robolingo Co., Ltd.
                  </p>
                </v-flex>
              </v-layout>
            </div>

            <div v-if="false" class="text-xs-center">
              <v-hover>
                <a
                  slot-scope="{ hover }"
                  href="https://forms.gle/aSXqHuQ4XGNp8Xj1A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <v-img
                    :class="`elevation-${hover ? 5 : 2}`"
                    class="hidden-xs-only"
                    src="/static/img/assets/_global/ads_for_web.png"
                    alt
                    style="
                      width: 100%;
                      max-width: 600px;
                      border-radius: 10px;
                      border: 1px solid #eee;
                      margin: auto;
                      cursor: pointer;
                      transition: all 0.5s ease;
                    "
                  ></v-img>
                  <v-img
                    :class="`elevation-${hover ? 5 : 2}`"
                    class="hidden-sm-and-up"
                    src="/static/img/assets/_global/ads_for_web_mobile.png"
                    alt
                    style="
                      width: 100%;
                      max-width: 600px;
                      border-radius: 10px;
                      border: 1px solid #eee;
                      margin: auto;
                      cursor: pointer;
                      transition: all 0.5s ease;
                    "
                  ></v-img>
                </a>
              </v-hover>
            </div>
          </v-container>
        </div>
      </div>

      <div style="background: white"></div>

      <v-dialog v-model="showTurnOnPermission" width="600">
        <v-card>
          <v-card-text>
            <h3 class="headline text-xs-center">{{ $t('Help') }}</h3>

            <div class="text-xs-center">
              <div class="row">
                <div class="col s12">
                  <p class="brand-primary">
                    {{ $t('Please enable all options and try to login again') }}
                  </p>
                  <p>
                    {{
                      $t(
                        'Also, you need to have at least one Facebook Page to install chatbot. Go to'
                      )
                    }}
                    <a
                      href="https://www.facebook.com/pages/creation/"
                      target="_blank"
                      rel="noopener noreferrer"
                      >https://www.facebook.com/pages/creation/</a
                    >
                    {{ $t('to create one and try to login again') }}
                  </p>

                  <img
                    src="/static/img/help_turn_on_permission.png"
                    alt
                    style="width: 100%; max-width: 500px; box-shadow: 0px 3px 6px #00000033"
                  />
                </div>
              </div>
            </div>

            <div style="padding: 15px" class="text-xs-center">
              <v-btn color="primary" depressed @click="showTurnOnPermission = false">{{
                $t('cancel')
              }}</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-content>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config'
import GetStarted from '@/components/view/getstarted/GetStarted'
import LangDropdown from '@/components/elements/LangDropdown'

export default {
  name: 'LoginComponent',
  components: {
    GetStarted,
    LangDropdown
  },
  data: function () {
    return {
      userid: '',
      error: null,
      fbSignInParams: {
        scope: config.fb_scope,
        return_scopes: true
      },
      showTurnOnPermission: false,
      isGetStarted: false,
      loading: true,
      isNewBusinessAccount: false
    }
  },

  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    })
  },
  mounted: async function () {
    var vm = this
    vm.loading = true
    await vm.handleLoadFacebookSDK(document, 'script', 'facebook-jssdk')
    await vm.handleInitFB()
    vm.$store.dispatch('logout', null).then(function () {})
    await this.$nextTick()
    if (window.FB) {
      const loginFBResponse = await vm.handleGetLoginStatus()

      if (loginFBResponse && loginFBResponse.status && loginFBResponse.status == 'connected') {
        await vm.handleFBLogout()
      }
    }

    if (localStorage.getItem('allowed_business_management') == 'true') {
      this.isNewBusinessAccount = true
      this.fbSignInParams.scope += ',business_management'
    }

    if (vm.$store.state.systemError && vm.$store.state.systemError.message) {
      vm.error = vm.$store.state.systemError.message
    }
    setTimeout(() => {
      vm.$nextTick(function () {
        vm.$store.commit('CLEAR_LOADING')
      })
    }, 3000)

    vm.loading = false
  },
  methods: {
    handleInitFB() {
      window.fbAsyncInit = function () {
        // eslint-disable-next-line no-undef
        window.FB.init({
          appId: config.appid,
          cookie: true, // enable cookies to allow the server to access the session
          xfbml: true, // parse social plugins on this page
          version: 'v4.0'
          // auth: true
        })
      }
    },
    async handleLoadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    },
    handleFBLogout() {
      return new Promise((resolve) => {
        window.FB.logout(function (response) {
          resolve(response)
        })
      })
    },
    handleGetLoginStatus() {
      return new Promise((resolve) => {
        // {
        //     status: 'connected',
        //     authResponse: {
        //         accessToken: '{access-token}',
        //         expiresIn:'{unix-timestamp}',
        //         reauthorize_required_in:'{seconds-until-token-expires}',
        //         signedRequest:'{signed-parameter}',
        //         userID:'{user-id}'
        //     }
        // }
        window.FB.getLoginStatus(function (response) {
          resolve(response)
        })
      })
    },
    onSignIn: function () {
      var vm = this
      window.FB.login(function (response) {
        var isAuth = vm.validateScope(response)
        if (isAuth && response.status === 'connected') {
          localStorage.removeItem('allowed_business_management')
          vm.onSignInSuccess(response)
        }
      }, vm.fbSignInParams)
    },
    validateScope: function (response) {
      var scopes = this.fbSignInParams.scope.replace(' ', '').split(',')

      if (response.authResponse && response.authResponse.grantedScopes) {
        if (scopes.length > 0) {
          scopes.map(function (scope) {
            if (!response.authResponse.grantedScopes.includes(scope)) {
              return false
            }
          })
        }
      } else {
        return false
      }

      return true
    },
    loginByUsername: function () {
      let vm = this
      vm.$store
        .dispatch('login', {
          userid: vm.userid,
          password: vm.password
        })
        .then(
          function () {
            vm.$router.push({
              path: '/' + vm.currentLang + '/allbots',
              query: vm.$route.query
            })
          },
          function (error) {
            vm.error = error.message
          }
        )
    },
    onSignInSuccess(response) {
      let vm = this
      var isAuth = vm.validateScope(response)
      if (!isAuth) {
        vm.showTurnOnPermission = true
        return false
      }

      if (response.status === 'connected') {
        vm.$store
          .dispatch('loginFB', {
            accessToken: response.authResponse.accessToken,
            userid: response.authResponse.userID,
            channel: 'facebook',
            scope: config.fb_scope
          })
          .then(
            function () {
              // var utm = ''
              // if (vm.$route.query.utm_source) {
              //   utm = vm.$route.query.utm_source
              // }
              // var prefix = window.location.hostname == 'cms.zwiz.ai' ? 'z_' : ''
              if (vm.$store.getters.botlist.length === 0) {
                // vm.$ga.event('event', prefix + 'new_subscriber', utm)
                vm.isGetStarted = true
              } else {
                // vm.$ga.event('event', prefix + 'login_fb', utm)

                // var supportcode = vm.$route.query.supportcode
                //   ? '&supportcode=' + vm.$route.query.supportcode
                //   : ''
                vm.$router.push({
                  path: '/' + vm.currentLang + '/allbots',
                  query: vm.$route.query
                })
                // Load language setting
                // api.getTutoriallist(function (error, response) {
                //   if (error) {
                //     console.error(error)
                //     return
                //   }
                //   if (response.data) {
                //     if (['en', 'th'].includes(response.data.lang)) {
                //       window.location.href = '/' + response.data.lang + '/allbots'
                //     } else {

                //     }
                //   } else {
                //     vm.$router.push('/' + vm.currentLang + '/allbots')
                //   }
                // })
              }
            },
            function (error) {
              vm.error = error.message
            }
          )
      } else {
        vm.error = 'Unable to connect Facebook'
      }
    },
    onSignInError(error) {
      var vm = this
      vm.error = error.message
    }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/login/Login.vue